<template>
    <div>
        <el-form :model="landSearchFilter" ref="projectForm" :rules="rules" label-position="left" class="employer-ruleForm">
        <el-row>
            <el-col :span="12">
                <el-form-item label="投资日期" prop="startDate"  :label-width="labelWidth">
                    <el-date-picker size="large" value-format="yyyy-MM-dd" v-model="landSearchFilter.date1" type="date"
                        placeholder="选择开始时间"></el-date-picker> -
                    <el-date-picker v-model="landSearchFilter.date2"  value-format="yyyy-MM-dd" type="date"
                        placeholder="选择结束时间"></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                    <el-form-item label="投资地点" prop="area" :label-width="labelWidth">
                        <!-- <el-select class="seletc-size-input" v-model="landSearchFilter.region" @change="regionChange" placeholder="请选择">
                            <el-option v-for="(item, index) in regionList" :key="index" :value="item.value"
                            :label="item.label"></el-option>
                        </el-select> -->
                        <!-- :disabled="landSearchFilter.region==0"  -->
                        <el-select class="seletc-size-input-2" v-model="landSearchFilter.province" placeholder="请选择"
                            @change="onProvinceChange('area', $event)">
                            <el-option value="" label="全部"></el-option>
                            <el-option v-for="(item) in provinceList" :key="item.areaId"
                                :value="item.areaId" :label="item.areaName"></el-option>
                        </el-select>
                        <el-select class="seletc-size-input-2" v-model="landSearchFilter.city" placeholder="请选择"
                            @change="onCityChange('area', $event)" :disabled="landSearchFilter.province==''">
                             <el-option value="" label="全部"></el-option>
                            <el-option v-for="(item, index) in lists.area.cityList" :key="index" :value="item.areaId"
                                :label="item.areaName"></el-option>
                        </el-select>
                        <!-- <el-select  class="seletc-size-input" v-model="landSearchFilter.countyList" 
                            v-show="landSearchFilter.isCountyList"
                            multiple
                            filterable
                            allow-create
                            default-first-option
                            @change="countyListChange($event)"
                            placeholder="">
                            <el-option value="" label="全部"></el-option>
                            <el-option
                            v-for="item in lists.area.countyList"
                            :key="item.areaId"
                            :label="item.areaName"
                            :value="item.areaId">
                            </el-option>
                        </el-select> -->
                       <!-- <el-checkbox v-model="landSearchFilter.isCountyList">多个区县</el-checkbox> -->
                    </el-form-item>
                </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="概念" prop="notionCode1" :label-width="labelWidth">
                    <el-select class="seletc-size-input-2" @change="changeClass(1,$event)" v-model="landSearchFilter.notion1" placeholder="请选择">
                        <el-option value="" label="全部"></el-option>
                        <el-option v-for="(item, index) in notionClassList1" :key="index" :value="item.paraValue"
                            :label="item.paraName"></el-option>
                    </el-select>
                    <el-select class="seletc-size-input-2" @change="changeClass(2,$event)" v-model="landSearchFilter.notion2" placeholder="请选择">
                        <el-option value="" label="全部"></el-option>
                        <el-option v-for="(item, index) in notionClassList2" :key="index" :value="item.paraValue"
                            :label="item.paraName"></el-option>
                    </el-select>
                   
                </el-form-item>
            </el-col>
            <el-col :span="12">
                    <el-form-item label="投资企业区域" prop="sourceProvince" :label-width="labelWidth">
                        <el-select class="seletc-size-input" v-model="landSearchFilter.sourceProvince"
                            placeholder="请选择" @change="onProvinceChange('source', $event)">
                            <el-option value="" label="全部"></el-option>
                            <el-option value="998" label="省外"></el-option>
                            <el-option value="997" label="市外"></el-option>
                            <el-option v-for="(item) in provinceList" :key="item.areaId" :value="item.areaId"
                                :label="item.areaName"></el-option>
                        </el-select>
                        <el-select class="seletc-size-input" v-model="landSearchFilter.sourceCity" placeholder="请选择"
                            @change="onCityChange('source', $event)" :disabled="landSearchFilter.sourceProvince==''">
                             <el-option value="" label="全部" v-show="landSearchFilter.sourceProvince!= '998'|| landSearchFilter.sourceProvince!= '997'"></el-option>
                            <el-option v-for="(item, index) in lists.source.cityList" :key="index" :value="item.areaId"
                                :label="item.areaName"></el-option>
                        </el-select>
                        <el-select class="seletc-size-input" v-model="landSearchFilter.sourceCounty" placeholder="请选择"
                            @change="onCountyChange('source', $event)" :disabled="landSearchFilter.sourceCity==''">
                            <el-option value="" label="全部"></el-option>
                            <el-option v-for="(item, index) in lists.source.countyList" :key="index" :value="item.areaId"
                                :label="item.areaName"></el-option>
                        </el-select>
                        <!-- <el-checkbox-group v-model="checkedCities" :max="1">
                            <el-checkbox v-model="landSearchFilter.sourceExclude">剔除本省数据</el-checkbox>
                        </el-checkbox-group> -->
                        <el-radio v-model="landSearchFilter.sourceExclude" label="1">剔除本省数据</el-radio>
                        <el-radio v-show="landSearchFilter.sourceCity!=''" v-model="landSearchFilter.sourceExclude" label="2">剔除本市数据</el-radio>
                    </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="行业" prop="bigLandUseList" :label-width="labelWidth">
                    <!-- 修改：el-option 的 value 改为整个 item，方便获取完整对象；并保留第一个 select 的 @change -->
                            <el-select class="seletc-size-input-2" v-model="landSearchFilter.industry1" placeholder="请选择"
                                @change="changeindustryClass(1,$event)">
                                <el-option value="" label="全部"></el-option>
                                <el-option v-for="item in industryClassList1" :key="item.paraValue" :label="item.name"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <!-- 修改：为第二个 select 添加 @change，并把 :value 改为 item -->
                            <el-select class="seletc-size-input-2" v-model="landSearchFilter.industry2" placeholder="请选择" 
                                @change="changeindustryClass(2, $event)">
                                <el-option value="" label="全部"></el-option>
                                <el-option v-for="item in industryClassList2" :key="item.paraValue" :label="item.name"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <!-- 修改：为第三个 select 添加 @change，并把 :value 改为 item -->
                            <!-- <el-select class="seletc-size-input" v-model="landSearchFilter.industry3" placeholder="请选择" 
                                @change="changeindustryClass(3, $event)">
                                <el-option value="" label="全部"></el-option>
                                <el-option v-for="item in industryClassList3" :key="item.paraValue" :label="item.name"
                                    :value="item.value">
                                </el-option>
                            </el-select> -->
                </el-form-item>
            </el-col>
            
             
            <!-- <el-col :span="12">
                <el-form-item label="产业分类" prop="bigLandUseList" :label-width="labelWidth">
                    
                            <el-select class="seletc-size-input" v-model="landSearchFilter.notion1" placeholder="请选择"
                                @change="changeClass(1,$event)">
                                <el-option v-for="item in notionClassList1" :key="item.paraValue" :label="item.paraName"
                                    :value="item.paraValue">
                                </el-option>
                            </el-select>
                            <el-select class="seletc-size-input" v-model="landSearchFilter.notion2" placeholder="请选择" 
                                @change="changeClass(2, $event)">
                                <el-option v-for="item in notionClassList2" :key="item.paraValue" :label="item.paraName"
                                    :value="item.paraValue">
                                </el-option>
                            </el-select>
                </el-form-item>
            </el-col> -->
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="投资模式" prop="minSize" :label-width="labelWidth">
                    <el-select class="seletc-size-input-1" v-model="landSearchFilter.investMode" placeholder="请选择">
                        <el-option value="" label="全部"></el-option>
                        <el-option v-for="(item, index) in investModeList" :key="index" :value="item.paraValue"
                            :label="item.paraName"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="融资方式" prop="minPrice" :label-width="labelWidth">
                    <el-select class="seletc-size-input-1" v-model="landSearchFilter.financeMode" placeholder="请选择">
                        <el-option value="" label="全部"></el-option>
                        <el-option v-for="(item, index) in financeModeList" :key="index" :value="item.paraValue"
                            :label="item.paraName"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="公司名称" prop="enterprise" :label-width="labelWidth">
                    <el-input class="text-input" v-model="landSearchFilter.enterprise" placeholder=""></el-input>
                </el-form-item> 
            </el-col>
            <el-col :span="12">
                <el-form-item label="项目名称" prop="project" :label-width="labelWidth">
                    <el-input class="text-input" v-model="landSearchFilter.project" placeholder=""></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="金额 >= " prop="money2" :label-width="labelWidth">
                    <el-input class="text-input" v-model="landSearchFilter.money2" placeholder=""></el-input>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
    <div class="btn oh mr-8 mb-2">
        <div class="fr">
             <el-button icon="el-icon-search" type="primary" @click="search">查询</el-button>
            <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </div>
    </div>
    </div>
</template>
<script>
    import { dataInJs } from "@/utils/city.js";
export default {
    name: 'landFilterCom',
    data() {
        return {
            labelWidth: '120px',
            rules: {},
            provincedata: [],
            regionList: [
                { value: 0, label: '全部' },
                { value: 1, label: '境内' },
                { value: 2, label: '境外' },
            ], 
            lists: {
                area: {
                    cityList: [],
                    countyList: []
                },
                source: {
                    cityList: [],
                    countyList: []
                }
            },
            landSearchFilter: {
                date1: '',
                date2: '',
                notion1: '',
                notion2: '',
                notion3: '',
                industry1: '',
                industry2: '',
                industry3: '',
                provinceid: 44,
                cityid: '',
                countyid: '',
                sourceProvince: '',
                sourceCity: '',
                sourceCounty: '',
                region: '',
                enterprise: '',
                project: '',
                money2: '',
                investMode: 35,
                financeMode: '',
            },
            investModeList: [
                { value: '1', label: '自有' },
                { value: '2', label: '合作' },
            ],
            financeModeList: [
                { value: '1', label: '融资' },
                { value: '2', label: '自筹' },
            ],
            provinceList: dataInJs(),
            cityList: [
                { value: '1', label: '保定' },
                { value: '2', label: '北京' },
                { value: '3', label: '石家庄' },
            ],
            countyList: [
                { value: '1', label: '东城区' },
                { value: '2', label: '西城区' },
                { value: '3', label: '海淀区' },
                { value: '4', label: '朝阳区' },
                { value: '5', label: '丰台区' },
                { value: '6', label: '石景山区' },
            ],
            bigLandUseList: [
                { value: '1', label: '住宅' },
                { value: '2', label: '商住' },
                { value: '3', label: '商住' },
                { value: '4', label: '商住' },
                { value: '5', label: '商住' },
                { value: '6', label: '商住' },
            ],
            smallLandUseList: [
                { value: '1', label: '住宅' },
                { value: '2', label: '商住' },
                { value: '3', label: '商住' },
                { value: '4', label: '商住' },
                { value: '5', label: '商住' },
                { value: '6', label: '商住' },
            ],
            notionClassList1: [],
            notionClassList2:[],
            industryClassList1: [],
            industryClassList2:[],
            industryClassList3: [],
        }
    },
    created() { 
    },
    mounted() { 
        this.getIndustryList(1);//获取行业分类
        this.getIndustryList(2);//概念分类 概念就是产业
        this.getIndustryList(3);//融资方式分类
        this.getIndustryList(4);//投资模式分类
    },
    methods: {
        //境内外区选择
        regionChange(value) {
            console.log(value);
            this.landSearchFilter.province = '';
            this.landSearchFilter.city = '';
            this.landSearchFilter.county = '';
            this.provinceList =[];
            this.cityList =[];
            this.countyList = [];

            this.lists.area.provinceList = [];
            this.lists.area.cityList = [];
            this.lists.area.countyList = [];
            this.lists.source.provinceList = [];
            this.lists.source.cityList = [];
            this.lists.source.countyList = [];
            if (value === 1) {
                //境内
                this.provinceList = dataInJs();
            }else if(value === 2){
                this.provinceList = [];
            }
            
            
        },
        //获取行业分类
        getIndustryList(type) { 
            this.$axios.get(this.$api.metall.investParam.List()+'?categoryId='+type).then((res) => {
               if (res.success) { 
                console.log('分类',res);
                if(type == 1){this.industryClassList1 = res.list;}//获取行业分类
                if(type == 2){this.notionClassList1 = res.list;}
                if(type == 3){this.financeModeList = res.list;}
                if(type == 4){this.investModeList = res.list;}
               } else {
                   this.$message.error(res.message);
               }
           })
        },
        changeindustryClass(step, value) {
            console.log('changeindustryClass', step, value);
            if (!value) {
                return;
            } 
            if (step == 1) { 
                this.industryClassList2 = this.industryClassList1.find(item => item.value == value).children || [];
                this.industryClassList3 = [];
                this.industry2 = '';
                this.industry3 = '';

            }else if (step == 2) {
                this.industryClassList3 = this.industryClassList2.find(item => item.value == value).children || [];
                this.industry3 = '';
            }else if (step == 3) {

            }
        },
        // 修改changeClass 现在接收完整的 selectedItem（整个对象）
        changeClass(step, value) {
            console.log('changeClass', step, value);
            if (!value) {
                return;
            } 
            if (step == 1) { 
                this.notionClassList2 = this.notionClassList1.find(item => item.paraValue == value).children || [];
                this.notionClassList3 = [];
                this.landSearchFilter.notion2 = '';
                this.landSearchFilter.notion3 = '';

            }else if (step == 2) {
            }
        },
        onProvinceChange(target, value) {
            // 清理对应字段
            if (target === 'area') {
                this.landSearchFilter.province = value;
                this.landSearchFilter.city = '';
                this.landSearchFilter.county = '';
            } else {
                this.landSearchFilter.sourceProvince = value;
                this.landSearchFilter.sourceCity = '';
                this.landSearchFilter.sourceCounty = '';
            }

            // 根据省获取城市
            const selectedProvince = this.provinceList.find(item => item.areaId === value);
            if (selectedProvince && selectedProvince.children) {
                this.lists[target].cityList = selectedProvince.children;
            } else {
                this.lists[target].cityList = [];
            }
            // 清空县列表
            this.lists[target].countyList = [];
        },

        onCityChange(target, value) {
            // 清理对应县及设置 city
            if (target === 'area') {
                this.landSearchFilter.city = value;
                this.landSearchFilter.county = '';
            } else {
                this.landSearchFilter.sourceCity = value;
                this.landSearchFilter.sourceCounty = '';
            }

            // 根据 city 获取 county
            const selectedCity = this.lists[target].cityList.find(item => item.areaId === value);
            if (selectedCity && selectedCity.children) {
                this.lists[target].countyList = selectedCity.children;
            } else {
                this.lists[target].countyList = [];
            }
        },

        onCountyChange(target, value) {
            if (target === 'area') {
                this.landSearchFilter.county = value;
            } else {
                this.landSearchFilter.sourceCounty = value;
            }
        },
        search() {
            this.$emit('search', this.landSearchFilter)
        },
        reset() {
            this.landSearchFilter = {
                date1: '',
                date2: '',
                notion1: '',
                notion2: '',
                notion3: '',
                industry1: '',
                industry2: '',
                industry3: '',
                provinceid: '',
                cityid: '',
                countyid: '',
                sourceProvince: '',
                sourceCity: '',
                sourceCounty: '',
                region: '',
                enterprise: '',
                project: '',
                money2: '',
                investMode: '',
                financeMode: '',
            }
        }
    }
}
</script>
<style scoped lang="scss">
::v-deep {
    .el-radio__inner{
        border-radius: 10%;
        ::after{
                width: 4px;
                content: 'V';
                height: 7px;
                /* border-radius: 100%; */
                /* background-color: #FFF; */
                /* content: ""; */
                position: absolute;
                color: #fff;
                left: 31%;
                top: 8%;
                transform: translate(-50%, -50%) scale(0);
                transition: tra
        }
    }
    .text-input{
        width: 70%
    }
    .el-input__inner{
        font-size: 14px;
        // line-height: 80px;
        height: 38px;
    }
    .el-form-item__label{
        font-weight: bold;
        font-size: 16px;
        color: #333;
    }
    .num-size-input{
        width: 180px;
    }
    .seletc-size-input {
        width: 140px;
    }
    .seletc-size-input-2 {
        width: 220px;
    }
    .seletc-size-input-1 {
        width: 470px;
    }
}
</style>